import SeoHead from "../../components/Seo/SeoHead";
import styles from "./About.module.css";

const BELIEFS = [
  {
    title: "Simplicidade que funciona",
    text: "Configuração em minutos, não em semanas. Se precisa de manual, a gente errou.",
  },
  {
    title: "Feito pro seu segmento",
    text: "Nada de solução genérica: o bot fala a língua da sua área e resolve a dor real do seu dia.",
  },
  {
    title: "Do lado de quem empreende",
    text: "Preço que cabe no caixa, teste sem cartão e cancelamento quando quiser. Sem pegadinha.",
  },
];

const About = () => (
  <div className={styles.page}>
    <SeoHead
      title="Sobre a Nexus Tech | Chatbot de agendamento no WhatsApp"
      description="Conheça a Nexus Tech: automação de atendimento e agenda no WhatsApp e Instagram para barbearias, consultórios, mecânicas, lava-jatos e academias."
      canonical="https://nexustech.tec.br/about"
    />

    {/* ── Hero ── */}
    <section className={styles.plainSection}>
      <div className={styles.contentNarrow}>
        <h1 className={styles.heroTitle}>Sobre a Nexus Tech</h1>
        <p className={styles.heroSubtitle}>
          A gente automatiza o atendimento e a agenda de pequenos negócios
          brasileiros — pra você focar no que faz de melhor.
        </p>
      </div>
    </section>

    {/* ── Quem somos / Missão ── */}
    <section className={styles.tintedSection} aria-labelledby="quem-somos">
      <div className={styles.contentNarrow}>
        <h2 id="quem-somos" className={styles.sectionHeading}>
          Quem somos
        </h2>
        <p className={styles.bodyText}>
          A Nexus Tech nasceu de uma frustração simples: dono de negócio perde
          cliente (e hora de sono) respondendo WhatsApp e remarcando horário na
          mão. Hoje são dois chatbots, no WhatsApp e no Instagram: um que
          responde o seu cliente 24 horas, e outro que faz isso e ainda cuida da
          agenda — marcando, confirmando e lembrando sozinho.
        </p>
        <p className={styles.missionCallout}>
          Nossa missão: tornar a automação de atendimento acessível pra quem
          está começando — sem TI, sem contrato longo, sem complicação.
        </p>
      </div>
    </section>

    {/* ── No que acreditamos ── */}
    <section className={styles.plainSection} aria-labelledby="acreditamos">
      <div className={styles.contentWide}>
        <h2 id="acreditamos" className={styles.sectionHeading}>
          No que acreditamos
        </h2>
        <ul className={styles.beliefGrid}>
          {BELIEFS.map((belief) => (
            <li key={belief.title} className={styles.beliefCard}>
              <h3 className={styles.beliefTitle}>{belief.title}</h3>
              <p className={styles.beliefText}>{belief.text}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>

    {/* ── Dados da empresa ── */}
    <section className={styles.tintedSection} aria-labelledby="dados-empresa">
      <div className={styles.contentNarrow}>
        <h2 id="dados-empresa" className={styles.sectionHeading}>
          Dados da empresa
        </h2>
        <dl className={styles.dataCard}>
          <div className={styles.dataRow}>
            <dt className={styles.dataLabel}>Razão social</dt>
            <dd className={styles.dataValue}>Leivas &amp; Leivas Ltda</dd>
          </div>
          <div className={styles.dataRow}>
            <dt className={styles.dataLabel}>CNPJ</dt>
            <dd className={styles.dataValue}>18.178.734/0001-20</dd>
          </div>
          <div className={styles.dataRow}>
            <dt className={styles.dataLabel}>Contato comercial</dt>
            <dd className={styles.dataValue}>
              <a className={styles.dataLink} href="mailto:contato@nexustech.tec.br">
                contato@nexustech.tec.br
              </a>
              <span className={styles.dataSep} aria-hidden="true">
                ·
              </span>
              <a className={styles.dataLink} href="tel:+5551992747402">
                +55 51 99274-7402
              </a>
            </dd>
          </div>
          <div className={styles.dataRow}>
            <dt className={styles.dataLabel}>Atendimento</dt>
            <dd className={styles.dataValue}>Florianópolis/SC · 100% online</dd>
          </div>
        </dl>
      </div>
    </section>
  </div>
);

export default About;
